/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrUpgradeActionSpec } from './irrUpgradeActionSpec';
import { IrrGwCertUpdateActionSpec } from './irrGwCertUpdateActionSpec';
import { RotatableOAuthAppTypeEnum } from './rotatableOAuthAppTypeEnum';
import { OAuthAppRotateActionSpec } from './oAuthAppRotateActionSpec';
import { RolloutType } from './rolloutType';


/**
 * Specification for a rollout action.
 */
/**
 * @type RolloutActionSpec
 * Specification for a rollout action.
 * @export
 */
export type RolloutActionSpec = IrrGwCertUpdateActionSpec | IrrUpgradeActionSpec | OAuthAppRotateActionSpec;

